export default {
	DATE: {
		DAY: "Day",
		WEEK: "Week",
		MONTH: "Month",
		YEAR: "Year",
	},
	SESSIONS: {
		ALL: "All",
		APP: "App",
		HOTLINE: "Hotline"
	},
	RISK: [
		{
			color: "#00c4b3",
			short: "Bel. Average",
			description: "Below average"
		},
		{
			color: "#0055b8",
			short: "Average",
			description: "Average"
		},
		{
			color: "#f8e71c",
			short: "Sli. high",
			description: "Slightly higher than average"
		},
		{
			color: "#dc6a28",
			short: "Mod. high",
			description: "Moderately higher than average"
		},
		{
			color: "#f5222d",
			short: "Sev. high",
			description: "Severely higher than average"
		}
	]
};


// WEBPACK FOOTER //
// ./src/constants/graph.js